module.exports = __webpack_public_path__ + "img/kc9.4ed9fc58.png";